import { useEffect, useState } from "react";
import styles from "./guides.module.css";
import { useTranslation } from "react-i18next";
import { Button, Select } from "../../uikit";
import {
  getShadowsocksLink,
  getShadowsocksQr,
} from "../../utils/DownloadConfig";
import { useNavigate } from "react-router";
import { AnimatePresence, motion } from "motion/react";
import { opacityVariants } from "../../routesVariants";
import { getToken } from "../../utils/tokenStorage";

const GuideShadowsocksData = ({ servers, subscription, type, label }) => {
  const navigate = useNavigate();
  const { t, _ } = useTranslation();
  const [selectedHostname, setSelectedHostname] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [link, setLink] = useState("");

  useEffect(() => {
    if (servers.length) {
      setSelectedHostname(servers[0].hostname);
    }
  }, [servers]);

  const setSelectedHostnameHandler = (event) => {
    setSelectedHostname(event.target.value);
  };

  const download = async () => {
    try {
      setIsLoading(true);
      setLink("");

      const token = getToken();
      if (token == "" || token == null) {
        navigate("/login");
      }

      if (type == "qr") {
        await getShadowsocksQr(token, subscription.id, selectedHostname);
        return;
      }

      const result = await getShadowsocksLink(
        token,
        subscription.id,
        selectedHostname
      );

      if (result.success) {
        setLink(result.link);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={`${styles.container} ${styles["min-height"]}`}>
      {label != "" ? (
        <div className={`${styles.wrap} label mb-025`}>{label}</div>
      ) : (
        <></>
      )}
      <div className={`${styles["bg-all"]}`}>
        <Select className={styles.bg} onChange={setSelectedHostnameHandler}>
          {servers.map((row) => (
            <option
              value={row.hostname}
              selected={row.hostname === selectedHostname}
            >
              {row.location}
            </option>
          ))}
        </Select>
      </div>
      <div className={styles.row}>
        {type == "link" ? (
          <Button loading={isLoading} onClick={() => download()} mode="outline">
            {t("Show configuration link")}
          </Button>
        ) : (
          <Button loading={isLoading} onClick={() => download()} mode="outline">
            {t("Download the QR-code")}
          </Button>
        )}
      </div>
      {type == "link" && (
        <AnimatePresence exitBeforeEnter>
          <motion.div
            key={link}
            className="flex"
            variants={opacityVariants}
            initial="initial"
            animate="final"
            exit="exit"
          >
            <div className={`${styles.wrap} ${styles.row} bold mt-1 `}>
              {link}
            </div>
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
};

export default GuideShadowsocksData;
